/***************************************** INITIAL STATE ********************************************/
export const INITIAL_STATE = {
    showCreateExcelAssignmentModal: false,
}

/***************************************** ACTION TYPES *********************************************/
const reducerName = 'AUTHORIZED_LAYOUT_'
const actionTypes = {
    SET_SHOW_CREATE_EXCEL_ASSIGNMENT_MODAL: `${reducerName}SET_SHOW_CREATE_EXCEL_ASSIGNMENT_MODAL`,
    CLEAR: `${reducerName}CLEAR`,
}

/******************************************** ACTIONS ***********************************************/
export const actions = {
    setShowCreateExcelAssignmentModal: value => ({
        type: actionTypes.SET_SHOW_CREATE_EXCEL_ASSIGNMENT_MODAL,
        payload: { value },
    }),
}

/******************************************* REDUCER ************************************************/
const authorizedLayoutReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SET_SHOW_CREATE_EXCEL_ASSIGNMENT_MODAL:
            return {
                ...state,
                showCreateExcelAssignmentModal: action.payload.value,
            }

        case actionTypes.CLEAR:
            return INITIAL_STATE

        default:
            return state
    }
}

export default authorizedLayoutReducer
